import { Link } from "react-router-dom";
import { Facebook, Twitter, Linkedin, Code2, Rocket } from "lucide-react";
import { ASSETS, NAV_LINKS, SOCIAL_LINKS } from "@/data/content";

export const SiteFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#0b0b0c] text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="self-start">
            <img src={ASSETS.logo} alt="Slingshot SEO" className="h-8 w-auto" />
          </div>

          <nav data-testid="footer-nav" className="flex flex-wrap gap-x-7 gap-y-3" aria-label="Footer">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                data-testid={`footer-${link.testId}`}
                className="font-nunito text-[12px] font-bold uppercase tracking-[0.14em] text-[#bdbdbd] hover:text-white transition-colors duration-150"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div data-testid="footer-social" className="flex items-center gap-4">
            <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Follow on Facebook" className="h-9 w-9 rounded-full border border-white/15 flex items-center justify-center text-[#bdbdbd] hover:text-white hover:border-white/40 transition-colors duration-150">
              <Facebook size={15} strokeWidth={1.75} />
            </a>
            <a href={SOCIAL_LINKS.twitter} target="_blank" rel="noopener noreferrer" aria-label="Follow on Twitter" className="h-9 w-9 rounded-full border border-white/15 flex items-center justify-center text-[#bdbdbd] hover:text-white hover:border-white/40 transition-colors duration-150">
              <Twitter size={15} strokeWidth={1.75} />
            </a>
            <a href={SOCIAL_LINKS.linkedin} target="_blank" rel="noopener noreferrer" aria-label="Follow on LinkedIn" className="h-9 w-9 rounded-full border border-white/15 flex items-center justify-center text-[#bdbdbd] hover:text-white hover:border-white/40 transition-colors duration-150">
              <Linkedin size={15} strokeWidth={1.75} />
            </a>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <p className="text-xs text-[#8a8a8a] leading-relaxed max-w-xl">
            © {year} Slingshot SEO. All rights reserved. Foundational SEO™, StrikingDistance™ and The
            Web Marketing Machine™ are trademarks of Slingshot SEO.
          </p>
          <Link
            to="/flatsome-export"
            data-testid="footer-flatsome-export-link"
            className="inline-flex items-center gap-2 rounded-[10px] border border-white/20 px-4 py-2.5 font-nunito text-[11px] font-extrabold uppercase tracking-[0.14em] text-[#dedede] hover:bg-white/10 transition-colors duration-150 self-start"
          >
            <Code2 size={15} strokeWidth={1.75} className="text-[#ee2e24]" />
            Flatsome 3.0 Export Spec
          </Link>
          <Link
            to="/deploy"
            data-testid="footer-deploy-link"
            className="inline-flex items-center gap-2 rounded-[10px] bg-[#ee2e24] px-4 py-2.5 font-nunito text-[11px] font-extrabold uppercase tracking-[0.14em] text-white hover:bg-[#d92820] transition-colors duration-150 self-start"
          >
            <Rocket size={15} strokeWidth={1.75} />
            Deploy Engine
          </Link>
        </div>
      </div>
    </footer>
  );
};
